/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import Loading from "../components/Loading";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField as MuiTextField,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  Button,
  Alert,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import { spacing } from "@mui/system";
import { Formik } from "formik";
import { connect } from "react-redux";
import axios from "../../CustomAxios";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const TextFieldSpacing = styled(MuiTextField)(spacing);

const TextField = styled(TextFieldSpacing)`
  width: 100%;
`;

function FormDetails({ ApCompanies, job, user }) {
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  useEffect(() => {}, [job]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [apUsers, setApUsers] = useState([]);
  const [loader, setLoader] = useState(false);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const getApUsers = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      let url = "";
      if (userData.type === "super_admin") {
        url = `/api/v1/super_admin/ap_user?company_id=${companyId}`;
      } else {
        url = `/api/v1/ap_user/ops?company_id=${companyId}`;
      }

      const { data } = await axios.get(url, config);
      if (data.success) {
        setApUsers(data.data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const approveJob = async (values, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      let docket = "";
      if (userData?.type === "super_admin") {
        docket = values.docket_by;
      } else {
        docket = user?._id;
      }
      let plates = [];
      values.plates.map((pl) => {
        const plate = {
          plate_id: pl.plate_id,
          gripper: pl.gripper,
          screen: pl.screen,
          set: pl.set,
          bake: pl.bake,
          printout: pl.printout,
          ctp_plate_count: pl.ctp_plate_count,
          quantity: pl.quantity,
        };
        plates.push(plate);
      });
      const { data } = await axios.put(
        `/api/v1/${userData?.type}/jobs/${job._id}/approve`,
        {
          ap_company: values.ap_company,
          ap_company_user: values.ap_company_user,
          docket_by: docket,
          delivery: values.delivery,
          ap_contact_number: values.ap_contact_number,
          customer_company: values?.customer_company._id,
          customer_company_user: values?.customer_company_user._id,
          name: values?.name,
          pc_ap: values?.pc_ap,
          total_form: values?.total_form,
          cut: values?.cut,
          open_height: values?.open_height,
          open_width: values?.open_width,
          page: values?.page,
          binding_style: values?.binding_style,
          required_date: values?.required_date,
          recieved_date: values?.received_date,
          fb: values?.fb,
          sb: values?.sb,
          dg: values?.dg,
          os: values?.os,
          instructions: values?.instructions,
          plates,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate("/dashboard/jobs", {
          state: { success: true, message: "Job Approved Successfully" },
        });
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };
  const [formChanged, setFormChanged] = useState(false);
  const { setPreventNavigation } = useOutletContext();

  useEffect(() => {
    if (formChanged) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [formChanged]);
  return (
    <>
      {/* General Details */}
      <Formik
        initialValues={{
          ap_company: "",
          ap_contact_number: "",
          customer_contact_number: job?.customer_contact_number,
          ap_company_user: "",
          customer_company: job?.customer_company,
          delivery: job?.delivery,
          customer_company_user: job?.customer_company_user,
          docket_by: authData?.type === "super_admin" ? "" : user?._id,
          name: job?.name,
          pc_ap: job?.pc_ap,
          total_form: job?.total_form,
          cut: job?.cut,
          open_height: job?.open_height,
          open_width: job?.open_width,
          page: job?.page,
          binding_style: job?.binding_style,
          required_date: job?.required_date,
          recieved_date: job?.received_date,
          fb: job?.fb || "",
          sb: job?.sb || "",
          dg: job?.dg || "",
          os: job?.os || "",
          instructions: job?.instructions,
          plates: job?.plates,
        }}
        validationSchema={Yup.object().shape({
          ap_company: Yup.string().required("Ap Company is required"),
          ap_company_user: Yup.string().required("Ap Company User is required"),
          customer_company: Yup.object().required(
            "Customer Company is required"
          ),
          ap_contact_number: Yup.string().required(
            "AP Company Number is required"
          ),
          customer_company_user: Yup.object().required(
            "Customer Company User is required"
          ),
          customer_contact_number: Yup.string().required(
            "Customer User Number is required"
          ),
          delivery: Yup.object().required("Address is required"),
          docket_by: Yup.string().required("Docket By is required"),
          name: Yup.string().required("Name is required"),
          pc_ap: Yup.string().required("PC/AP is required"),
          // total_form: Yup.string().required("Total Form is required"),
          cut: Yup.string().required("Cut is required"),
          open_height: Yup.string().required("Open-Height is required"),
          open_width: Yup.string().required("Open-Width is required"),
          page: Yup.string().required("Page is required"),
          binding_style: Yup.string().required("Binding Style is required"),
          required_date: Yup.date().required("Delivery Date is requried"),
          recieved_date: Yup.date().required("Recieved Date is requried"),
          fb: Yup.string().matches(/^[1-3]?[0-9]?[0-9]?[0-9]?$/, 'F/B should be in range 1 - 3999'),
          sb: Yup.string().matches(/^[1-3]?[0-9]?[0-9]?[0-9]?$/, 'S/B should be in range 1 - 3999'),
          dg: Yup.string().matches(/^[1-3]?[0-9]?[0-9]?[0-9]?$/, 'D/G should be in range 1 - 3999'),
          os: Yup.string().matches(/^[1-3]?[0-9]?[0-9]?[0-9]?$/, 'O/S should be in range 1 - 3999'),
          instructions: Yup.string(),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            approveJob(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values,
        }) => (
          <>
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Job Approved Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <form
                onChange={() => {
                  setFormChanged(true);
                  setPreventNavigation(true);
                }}
                noValidate
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item lg={12} md={12} xs={12}>
                          <Typography color="primary" variant="h6" gutterBottom>
                            General Details
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            fullWidth
                            inputProps={{ readOnly: true }}
                            value={values?.customer_company?.name || ""}
                            id="search-field"
                            label="Customer Company"
                          />
                        </Grid>
                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            fullWidth
                            inputProps={{ readOnly: true }}
                            value={values?.customer_company_user?.name || ""}
                            id="search-field"
                            label="Customer Company User"
                          />
                        </Grid>

                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            fullWidth
                            inputProps={{ readOnly: true }}
                            value={
                              values?.customer_company_user?.phone_number || ""
                            }
                            id="search-field"
                            label="Customer Contact Number"
                          />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.delivery && errors.delivery)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={job?.customer_company?.addresses}
                              defaultValue={values?.delivery}
                              value={values?.delivery}
                              onChange={(event, newValue) => {
                                setFormChanged(true);
                                setPreventNavigation(true);
                                setFieldValue("delivery", newValue || "");
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option?.address_line_one}, ${option?.address_line_two}, ${option?.city}, ${option?.state}, ${option?.pincode}, India`
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(
                                    touched.delivery && errors.delivery
                                  )}
                                  helperText={
                                    touched.delivery && errors.delivery
                                  }
                                  label="Delivery"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item lg={12} md={12} xs={12}>
                          <FormControl
                            error={Boolean(
                              touched.ap_company && errors.ap_company
                            )}
                            fullWidth
                          >
                            <Select
                              name="ap_company"
                              id="search-field"
                              value={values.ap_company || ""}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFormChanged(true);
                                setPreventNavigation(true);

                                handleChange("ap_company")(e);
                                getApUsers(e.target.value);
                              }}
                              displayEmpty
                            >
                              <MenuItem value={""} disabled>
                                Select AP Company
                              </MenuItem>
                              {ApCompanies.map((company) => {
                                return (
                                  <MenuItem value={company._id}>
                                    {company.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              Select Alpha Plus Company
                            </FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item lg={12} md={12} xs={12}>
                          <FormControl
                            error={Boolean(
                              touched.ap_company_user && errors.ap_company_user
                            )}
                            fullWidth
                          >
                            <Select
                              name="ap_company_user"
                              id="search-field"
                              value={values.ap_company_user || ""}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFormChanged(true);
                                setPreventNavigation(true);

                                handleChange("ap_company_user")(e);
                                let filterUser = apUsers.filter(
                                  (u) => u._id === e.target.value
                                )[0];
                                setFieldValue(
                                  "ap_contact_number",
                                  filterUser.phone_number || ""
                                );
                              }}
                              displayEmpty
                            >
                              <MenuItem value={""} disabled>
                                Select AP User
                              </MenuItem>
                              {apUsers.map((user) => {
                                return (
                                  <MenuItem value={user._id}>
                                    {user.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              Select Alpha Plus User
                            </FormHelperText>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <TextField
                            name="ap_contact_number"
                            fullWidth
                            inputProps={{ readOnly: true }}
                            value={values.ap_contact_number}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.ap_contact_number &&
                                errors.ap_contact_number
                            )}
                            helperText={
                              touched.ap_contact_number &&
                              errors.ap_contact_number
                            }
                            id="search-field"
                            label="AP Contact Number"
                          />
                        </Grid>

                        {authData?.type === "super_admin" ? (
                          <Grid item lg={12} md={12} xs={12}>
                            <FormControl
                              error={Boolean(
                                touched.docket_by && errors.docket_by
                              )}
                              fullWidth
                            >
                              <Select
                                name="docket_by"
                                id="search-field"
                                value={values.docket_by || ""}
                                onBlur={handleBlur}
                                onChange={(e) => {
                                  setFormChanged(true);
                                  setPreventNavigation(true);

                                  handleChange("docket_by")(e);
                                }}
                                displayEmpty
                              >
                                <MenuItem value={""} disabled>
                                  Select Docket By
                                </MenuItem>
                                {apUsers.map((user) => {
                                  return (
                                    <MenuItem value={user._id}>
                                      {user.name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                              <FormHelperText>Select Docket By</FormHelperText>
                            </FormControl>
                          </Grid>
                        ) : (
                          <Grid item lg={12} md={12} xs={12}>
                            <TextField
                              fullWidth
                              name="docket_by"
                              value={user?.name || ""}
                              id="search-field"
                              label="Docket By"
                            />
                          </Grid>
                        )}
                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            fullWidth
                            name="name"
                            inputProps={{ readOnly: true }}
                            value={values?.name || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            onChange={handleChange}
                            id="search-field"
                            label="Job Name"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="pc_ap"
                            value={values?.pc_ap || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.pc_ap && errors.pc_ap)}
                            helperText={touched.pc_ap && errors.pc_ap}
                            onChange={handleChange}
                            id="search-field"
                            label="PC-AP"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="total_form"
                            value={values?.total_form || ""}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.total_form && errors.total_form
                            )}
                            helperText={touched.total_form && errors.total_form}
                            onChange={handleChange}
                            id="search-field"
                            label="Total Form"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="cut"
                            value={values?.cut || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.cut && errors.cut)}
                            helperText={touched.cut && errors.cut}
                            onChange={handleChange}
                            id="search-field"
                            label="Cut"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="open_height"
                            value={values?.open_height || ""}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_height && errors.open_height
                            )}
                            helperText={
                              touched.open_height && errors.open_height
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Height"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="open_width"
                            value={values?.open_width || ""}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_width && errors.open_width
                            )}
                            helperText={touched.open_width && errors.open_width}
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Width"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="page"
                            value={values?.page || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.page && errors.page)}
                            helperText={touched.page && errors.page}
                            onChange={handleChange}
                            id="search-field"
                            label="Page"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="required_date"
                            value={
                              new Date(
                                values?.required_date
                              ).toLocaleDateString() +
                              " " +
                              new Date(values?.required_date).toTimeString()
                            }
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.required_date && errors.required_date
                            )}
                            helperText={
                              touched.required_date && errors.required_date
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Delivery Date"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            name="recieved_date"
                            value={
                              new Date(
                                values?.recieved_date
                              ).toLocaleDateString() +
                              " " +
                              new Date(values?.recieved_date).toTimeString()
                            }
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.recieved_date && errors.recieved_date
                            )}
                            helperText={
                              touched.recieved_date && errors.recieved_date
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Received Date"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="fb"
                            value={values?.fb || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.fb && errors.fb)}
                            helperText={touched.fb && errors.fb}
                            onChange={handleChange}
                            id="search-field"
                            label="F/B"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="sb"
                            value={values?.sb || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.sb && errors.sb)}
                            helperText={touched.sb && errors.sb}
                            onChange={handleChange}
                            id="search-field"
                            label="S/B"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="dg"
                            value={values?.dg || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.dg && errors.dg)}
                            helperText={touched.dg && errors.fb}
                            onChange={handleChange}
                            id="search-field"
                            label="D/G"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <TextField
                            fullWidth
                            type="number"
                            name="os"
                            value={values?.os || ""}
                            onBlur={handleBlur}
                            error={Boolean(touched.os && errors.os)}
                            helperText={touched.os && errors.os}
                            onChange={handleChange}
                            id="search-field"
                            label="O/S"
                          />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                          <FormControl
                            error={Boolean(
                              touched.binding_style && errors.binding_style
                            )}
                            fullWidth
                          >
                            <Select
                              name="binding_style"
                              id="search-field"
                              inputProps={{ readOnly: true }}
                              value={values?.binding_style || ""}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFormChanged(true);
                                setPreventNavigation(true);

                                handleChange("binding_style")(e);
                              }}
                              displayEmpty
                            >
                              <MenuItem value={""} disabled>
                                Select Binding Style
                              </MenuItem>
                              <MenuItem value={"perfect"}>Perfect</MenuItem>
                              <MenuItem value={"center_pinning"}>
                                Center Pining
                              </MenuItem>
                              <MenuItem value={"perfect_section"}>
                                Perfect Section
                              </MenuItem>
                              <MenuItem value={"wiro"}>Wiro</MenuItem>
                            </Select>
                            {/* <FormHelperText>Select binding Style</FormHelperText> */}
                          </FormControl>
                        </Grid>
                        <Grid item lg={12} md={12} xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            name="instructions"
                            inputProps={{ readOnly: true }}
                            value={values?.instructions || ""}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.instructions && errors.instructions
                            )}
                            helperText={
                              touched.instructions && errors.instructions
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Job Instructions"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography color="primary" variant="h6" gutterBottom>
                            Plate Details
                          </Typography>
                        </Grid>
                        {job.plates &&
                          job?.plates.map((pl) => {
                            return (
                              <>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.company}
                                    label="Company"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.technology.name}
                                    label="Technology"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.brand.name}
                                    label="Brand"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.hsn}
                                    label="hsn"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.height}
                                    label="Height"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.width}
                                    label="Width"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    value={pl.plate_details.thickness}
                                    label="Thickness"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="search-field"
                                    type="number"
                                    value={pl.gripper}
                                    label="Gripper"
                                    inputProps={{ readOnly: true }}
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    id="search-field"
                                    value={pl.screen}
                                    inputProps={{ readOnly: true }}
                                    label="Screen"
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    id="search-field"
                                    inputProps={{ readOnly: true }}
                                    value={pl.set}
                                    label="Set"
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    id="standard-number"
                                    label="Bake Quantity"
                                    fullWidth
                                    inputProps={{ readOnly: true }}
                                    value={pl.bake}
                                    type="number"
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    id="standard-number"
                                    label="Printout Quantity"
                                    value={pl.printout}
                                    inputProps={{ readOnly: true }}
                                    type="number"
                                    fullWidth
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    id="standard-number"
                                    label="ctp"
                                    value={pl.ctp_plate_count}
                                    inputProps={{ readOnly: true }}
                                    type="number"
                                  />
                                </Grid>
                                <Grid item xs={12} lg={3} md={6}>
                                  <TextField
                                    fullWidth
                                    disabled
                                    id="standard-number"
                                    label="Total Quantity"
                                    inputProps={{ readOnly: true }}
                                    value={pl.quantity}
                                    type="number"
                                  />
                                </Grid>
                                <Grid item xs={12} lg={9} md={6}></Grid>
                                <Grid item xs={12} lg={12} md={12}></Grid>
                              </>
                            );
                          })}
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Approve Job
                </Button>
              </form>
            ) : (
              <Loading />
            )}
          </>
        )}
      </Formik>
    </>
  );
}

const getUserCompanies = async (setApCompanies, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const apCompany = await axios.get(
      `/api/v1/${userData?.type}/ap_company`,
      config
    );
    if (apCompany.data.success) {
      setApCompanies(apCompany.data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const getJobDetail = async (id, setJob, setLoader, setApCompanies) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/jobs/${id}`,
      config
    );
    if (data.success) {
      setJob(data.data);
    }
    getUserCompanies(setApCompanies, setLoader);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

function ApproveJob({ auths }) {
  const location = useLocation();
  const [user, setUser] = useState([]);
  const [job, setJob] = useState([]);
  const [loader, setLoader] = useState(true);
  const [ApCompanies, setApCompanies] = useState([]);
  useEffect(() => {
    if (auths?.user) {
      setUser(auths.user);
      getJobDetail(location?.state?.job._id, setJob, setLoader, setApCompanies);
    }
    // eslint-disable-next-line
  }, [auths.user]);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              APPROVE JOBS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="dashboard/jobs/requested-jobs">
                Requested Jobs
              </Link>
              <Typography>Approve Job</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <GeneralDetails /> */}
            <FormDetails ApCompanies={ApCompanies} job={job} user={user} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ApproveJob);
